import React from 'react'
import ProductCarousel from '../../../productsComponents/productCarousel/ProductCarousel'
import PropTypes from 'prop-types'
import { getCategories } from '../../../../redux/selectors/planCategories'
import { connect } from 'react-redux'

const NUM_CATEGORY_CAROUSELS_TO_SHOW = 5

const ExploreCarousels = props => {
  const visibility = props.loaded ? 'visible' : 'hidden'

  return (
    <div className='carousels' style={{ visibility }}>
      {props.categories
        .slice(0, NUM_CATEGORY_CAROUSELS_TO_SHOW)
        .map((category, index) => (
          <ProductCarousel
            products={category.products.toModelArray()}
            title={category.title}
            link={category.slug}
            key={index}
          />
        ))}
    </div>
  )
}

ExploreCarousels.propTypes = {
  categories: PropTypes.array,
  loaded: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    categories: getCategories(state)
  }
}

export default connect(mapStateToProps)(ExploreCarousels)
